var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 13.3333,
    height: 15.3583,
    viewBox: "0 0 13.3333 15.3583",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66667 8.75C1.66667 7.375 2.225 6.125 3.13333 5.21667L1.95 4.03333C0.75 5.24167 0 6.90833 0 8.75C0 12.15 2.54167 14.95 5.83333 15.3583V13.675C3.475 13.275 1.66667 11.225 1.66667 8.75ZM13.3333 8.75C13.3333 5.06667 10.35 2.08333 6.66667 2.08333C6.61667 2.08333 6.56667 2.09167 6.51667 2.09167L7.425 1.18333L6.25 0L3.33333 2.91667L6.25 5.83333L7.425 4.65833L6.525 3.75833C6.575 3.75833 6.625 3.75 6.66667 3.75C9.425 3.75 11.6667 5.99167 11.6667 8.75C11.6667 11.225 9.85833 13.275 7.5 13.675V15.3583C10.7917 14.95 13.3333 12.15 13.3333 8.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.691f87d122e5f459bf600a44bea49b26.svg";
export { ForwardRef as ReactComponent };